/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsDeleteCatalogEntry } from "../../funcs/llmModelsDeleteCatalogEntry.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteModelCatalogEntryRequest$inboundSchema,
};

export const tool$llmModelsDeleteCatalogEntry: ToolDefinition<typeof args> = {
  name: "llm-models-delete-catalog-entry",
  description: `Remove a BYO catalog model

Withdraws a BYO definition and deactivates it only when the active name is sourced from that BYO lineage.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsDeleteCatalogEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
